import _slicedToArray from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["fetchPriority", "lazyLoading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';
import { imageWithPrefix } from '../../scripts/helpers';
import { placeholder } from '../../scripts/media';
var Image = function Image(_ref) {
  var fetchPriority = _ref.fetchPriority,
    lazyLoading = _ref.lazyLoading,
    rest = _objectWithoutProperties(_ref, _excluded);
  var placeholderRef = useRef(null);
  function updateOptions(props) {
    var opts = _objectSpread({}, props);
    if (opts.placeholder) delete opts.placeholder;
    opts.alt = opts.alt || '';
    if (lazyLoading) {
      opts.src = props.placeholder || placeholder;
      opts['data-src'] = props.src;
    } else {
      opts.src = imageWithPrefix(props.src);
    }
    // Add correct lowercase attribute if provided
    if (fetchPriority) {
      opts.fetchpriority = fetchPriority;
    }
    return opts;
  }
  var _useState = useState(function () {
      return updateOptions(rest);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  useEffect(function () {
    setOptions(updateOptions(rest));
    if (lazyLoading && placeholderRef.current) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && placeholderRef.current) {
            placeholderRef.current.setAttribute('src', imageWithPrefix(rest.src));
            obs.disconnect();
          }
        });
      }, {
        rootMargin: '300px',
        threshold: 0
      });
      observer.observe(placeholderRef.current);
      return function () {
        return observer.disconnect();
      };
    }
  }, [rest.src, lazyLoading]);
  return React.createElement("img", _objectSpread(_objectSpread({}, options), {}, {
    ref: lazyLoading ? placeholderRef : undefined,
    loading: lazyLoading ? 'lazy' : undefined
  }));
};
export default Image;